export const allDashboardWidgets = [
  {
    id: 1,
    icon: "mdi-account-check-outline",
    title: "Attendance",
    subTitle: "Attendance of the students",
    size: "MEDIUM",
    positionIndex: 1,
  },
  {
    id: 2,
    icon: "mdi-calendar-clock",
    title: "Events",
    subTitle: "Events of the month",
    size: "MEDIUM",
    positionIndex: 2,
  },
  {
    id: 3,
    icon: "mdi-account-school-outline",
    title: "Student Schedules",
    subTitle: "Schedules of the students",
    size: "LARGE",
    positionIndex: 3,
  },
  {
    id: 4,
    icon: "mdi-account-outline",
    title: "Teacher Schedules",
    subTitle: "Schedules of the teachers",
    size: "SMALL",
    positionIndex: 4,
  },
  {
    id: 5,
    icon: "mdi-check-underline-circle-outline",
    title: "Checklists Summary",
    subTitle: "Summary of student checklists",
    size: "FULL",
    positionIndex: 5,
  },
  {
    id: 6,
    icon: "mdi-account-alert-outline",
    title: "Consecutive Absences",
    subTitle: "Summary of student absences",
    size: "MEDIUM",
    positionIndex: 6,
  },
  {
    id: 7,
    icon: "mdi-account-alert-outline",
    title: "Ending Soon Enrollment",
    subTitle: "Enrollments will end within current week",
    size: "FULL",
    positionIndex: 7,
  },
  {
    id: 8,
    icon: "mdi-account-alert-outline",
    title: "Unmarked Attendances",
    subTitle: "Schedules with no attendances",
    size: "FULL",
    positionIndex: 8,
  },
  {
    id: 9,
    icon: "mdi-account-alert-outline",
    title: "Unmarked Checklists",
    subTitle: "Schedules with no checklists marked",
    size: "FULL",
    positionIndex: 9,
  },
  {
    id: 10,
    icon: "mdi-cash",
    title: "Unpaid Balances",
    subTitle: "Total unpaid balances",
    size: "SMALL",
    positionIndex: 10,
  },
  {
    id: 11,
    icon: "mdi-account-alert-outline",
    title: "Missing Enrollments",
    subTitle: "Enrollments are missing for students",
    size: "SMALL",
    positionIndex: 11,
  },
  {
    id: 12,
    icon: "mdi-account-group-outline",
    title: "Teacher leave-out",
    subTitle: "Leave-out summary for teachers",
    size: "MEDIUM",
    positionIndex: 12,
  },
];

export const allDashboardCards = [
  {
    id: 1,
    icon: "mdi-account-alert-outline",
    title: "Unmarked Attendance",
    subTitle: "Total unmarked schedules",
    positionIndex: 1,
  },
  {
    id: 2,
    icon: "mdi-account-cancel-outline",
    title: "Absent Attendance",
    subTitle: "Total absent schedules",
    positionIndex: 2,
  },
  {
    id: 3,
    icon: "mdi-account-school-outline",
    title: "Student Schedules",
    subTitle: "Total student schedules",
    positionIndex: 3,
  },
  {
    id: 4,
    icon: "mdi-account-tie-woman",
    title: "Teacher Schedules",
    subTitle: "Total teacher schedules",
    positionIndex: 4,
  },
];
